export default "__VITE_ASSET__BwRv88KF__"